import { type Components, type Theme } from "@mui/material";

export const MuiAppBar: Components<Theme>["MuiAppBar"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.grey[100],
      position: "fixed",
      color: theme.palette.text.primary,
    }),
  },
};
